import { BREAKPOINTS } from 'constants/Global/Breakpoints.const';
import styled from 'styled-components';

export const Container = styled.div`
  background: #ffeac2;
  padding: 12px 16px;
  margin: 8px;
  
  @media (min-width: ${BREAKPOINTS.desktop}) {
    margin: 24px 16px 8px;
    margin-left: 300px;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 12px;
  width: 100%;
  color: #000 !important;

  @media (min-width: ${BREAKPOINTS.desktop}) {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 24px;
  }
`;

export const Header = styled.div<{ $isMobile: boolean; $isExpanded: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 12px;
  cursor: ${({ $isMobile }) => ($isMobile ? 'pointer' : 'default')};
  user-select: none;

  &:focus-visible {
    outline: 2px solid #d16d0f;
    outline-offset: 2px;
    border-radius: 4px;
  }

  @media (min-width: ${BREAKPOINTS.desktop}) {
    width: auto;
    cursor: default;
    justify-content: flex-start;
  }
`;

export const TitleGroup = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  min-width: 0;
`;

export const Subtitle = styled.span`
  font-size: 0.75rem;
  font-weight: 400;
  color: #000;

  @media (min-width: ${BREAKPOINTS.desktop}) {
    display: none;
  }
`;

export const ChevronIcon = styled.span<{ $isExpanded?: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #d16d0f;
  font-size: 1rem;
  transition: transform 0.25s ease;
  transform: ${({ $isExpanded }) =>
    $isExpanded ? 'rotate(180deg)' : 'rotate(0deg)'};

  @media (min-width: ${BREAKPOINTS.desktop}) {
    display: none;
  }
`;

export const ControlsWrapper = styled.div<{ $isMobile?: boolean; $isVisible?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  overflow: hidden;
  max-height: ${({ $isMobile, $isVisible }) =>
    $isMobile && !$isVisible ? '0px' : '1200px'};
  opacity: ${({ $isMobile, $isVisible }) =>
    $isMobile && !$isVisible ? 0 : 1};
  margin-top: ${({ $isMobile, $isVisible }) =>
    $isMobile && !$isVisible ? '-12px' : '0'};
  pointer-events: ${({ $isMobile, $isVisible }) =>
    $isMobile && !$isVisible ? 'none' : 'auto'};
  transition: max-height 0.3s ease, opacity 0.25s ease, margin-top 0.3s ease;

  @media (min-width: ${BREAKPOINTS.desktop}) {
    max-height: none;
    opacity: 1;
    margin-top: 0;
    pointer-events: auto;
    overflow: visible;
    align-items: flex-end;
  }
`;

export const Title = styled.h3`
  margin: 0;
  font-size: 1rem;
  font-weight: 700;
  color: #d16d0f;

  @media (min-width: ${BREAKPOINTS.desktop}) {
    font-size: 1.25rem;
  }
`;

export const AlphabetWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;

  @media (min-width: ${BREAKPOINTS.desktop}) {
    justify-content: flex-end;
    width: auto;
  }
`;

export const ControlsGroup = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: flex-start;
  gap: 12px;

  @media (min-width: ${BREAKPOINTS.desktop}) {
    width: auto;
    gap: 16px;
  }
`;

export const Divider = styled.div`
  display: block;
  width: 1px;
  height: 16px;
  background-color: #d16d0f;
  margin: 0 8px;
`;

export const TooltipWrapper = styled.div`
  display: flex;
  align-items: center;
  color: #d16d0f;
  font-size: 1rem;
  cursor: pointer;

  &:hover {
    color: darken(#d16d0f, 10%);
  }
`;

export const TooltipText = styled.span`
  display: none;
  color: #000;
  font-size: 0.75rem;
  font-weight: 400;
  margin-left: 4px;

  @media (min-width: ${BREAKPOINTS.desktop}) {
    display: inline;
  }
`;

export const SwitchWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  .ant-switch-checked {
    background-color: #d16d0f !important;
  }
`;

export const SwitchLabel = styled.span`
  font-size: 0.75rem;
  font-weight: 500;
  white-space: nowrap;
`;

export const SelectWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  .ant-select {
    min-width: 60px;

    .ant-select-selector {
      box-shadow: none !important;
      padding: 0 4px;
      border-radius: 4px;
      background-color: #fff !important;
      color: #000 !important;
    }

    .ant-select-selection-item {
      color: #000 !important;
      font-weight: 600;
      font-size: 0.75rem;
    }

    .ant-select-arrow {
      color: #d16d0f;
    }

    &:hover .ant-select-selector {
      border: 1px solid white !important;
    }

    &.ant-select-focused .ant-select-selector {
      border: 1px solid white !important;
      box-shadow: none !important;
    }
  }
`;

export const SelectLabel = styled.span`
  display: none;
  font-size: 0.75rem;
  color: #000;
  font-weight: 500;
  white-space: nowrap;

  @media (min-width: ${BREAKPOINTS.desktop}) {
    display: inline;
  }
`;
